function _instanceof(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
function _instanceof1(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return _instanceof(left, right);
    }
}
/**
 * fetch handler
 *
 * statusCode
 * -1 = fetch error
 * -2 = read stream error
 * -3 = parse json error
 * -10 = timeout
 * @param input
 * @param requestInit
 * @param timeout in millisecond
 */ var fetchHandler = function fetchHandler(input, requestInit, timeout) {
    return new Promise(function(resolve) {
        var timer = setTimeout(function() {
            resolve({
                error: new Error("" + input + ": request timeout"),
                statusCode: -10,
                success: false
            });
        }, timeout);
        fetch(input, requestInit).then(function(response) {
            // cancel timer
            clearTimeout(timer);
            response.text() // transform to json object
            .then(function(raw) {
                try {
                    var parsed = JSON.parse(raw);
                    if (response.status >= 500) {
                        resolve({
                            data: parsed,
                            error: new Error(raw),
                            statusCode: response.status,
                            success: response.ok
                        });
                        return;
                    }
                    resolve({
                        data: parsed,
                        statusCode: response.status,
                        success: response.ok
                    });
                } catch (error) {
                    if (_instanceof1(error, SyntaxError) || _instanceof1(error, TypeError)) {
                        error.message = error + ";\n response: " + raw + ";\n statusCode: " + response.status;
                        resolve({
                            error: error,
                            statusCode: -3,
                            success: false
                        });
                        return;
                    }
                    throw error;
                }
            }) // handle general error
            .catch(function(error) {
                return resolve({
                    error: error,
                    statusCode: -2,
                    success: false
                });
            });
        }) // handle fetch error
        .catch(function(error) {
            // cancel timer
            clearTimeout(timer);
            resolve({
                error: error,
                statusCode: -1,
                success: false
            });
        });
    });
};

var getJson = function getJson(url, origin) {
    if (origin === void 0) origin = window.location.origin;
    return function(headers, queryParams) {
        return fetchHandler("" + origin + url + (!!queryParams ? "?" + new URLSearchParams(queryParams) : ''), {
            method: 'GET',
            headers: headers != null ? headers : {},
            credentials: 'same-origin'
        }, 30000);
    };
};

function _extends$2() {
    _extends$2 = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends$2.apply(this, arguments);
}
/**
 * safely send post request by json
 */ var postJson = function postJson(url, origin) {
    if (origin === void 0) origin = window.location.origin;
    return function(requestBody, headers) {
        return fetchHandler("" + origin + url, {
            method: 'POST',
            headers: _extends$2({}, headers, {
                'Content-Type': 'application/json; charset=utf-8'
            }),
            body: JSON.stringify(requestBody),
            credentials: 'same-origin'
        }, 30000);
    };
};

function _extends$1() {
    _extends$1 = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends$1.apply(this, arguments);
}
/**
 * safely send post request by json
 */ var patchJson = function patchJson(url, origin) {
    if (origin === void 0) origin = window.location.origin;
    return function(requestBody, headers) {
        return fetchHandler("" + origin + url, {
            method: 'PATCH',
            headers: _extends$1({}, headers, {
                'Content-Type': 'application/json; charset=utf-8'
            }),
            body: JSON.stringify(requestBody),
            credentials: 'same-origin'
        }, 30000);
    };
};

function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
/**
 * safely send post request by json
 */ var deleteJson = function deleteJson(url, origin) {
    if (origin === void 0) origin = window.location.origin;
    return function(requestBody, headers) {
        return fetchHandler("" + origin + url, {
            method: 'DELETE',
            headers: _extends({}, headers, {
                'Content-Type': 'application/json; charset=utf-8'
            }),
            body: JSON.stringify(requestBody),
            credentials: 'same-origin'
        }, 30000);
    };
};

var ULRequest = {
    getJson: getJson,
    postJson: postJson,
    patchJson: patchJson,
    deleteJson: deleteJson
};

var appendMultiDCPath = function(path, enabledMultiDC) {
    return enabledMultiDC ? "/mldc" + path : path;
};
var ULRequestUniversalLoginApiClient = function ULRequestUniversalLoginApiClient(ulApiOrigin, isMultiDCEnabled) {
    if (isMultiDCEnabled === void 0) isMultiDCEnabled = false;
    this.signIn = ULRequest.postJson(appendMultiDCPath('/ul/api/v1/signin', isMultiDCEnabled), ulApiOrigin);
    this.initialOtpLogin = ULRequest.getJson(appendMultiDCPath('/ul/api/v1/signin/otp', isMultiDCEnabled), ulApiOrigin);
    this.otpLogin = ULRequest.postJson(appendMultiDCPath('/ul/api/v1/signin/otp', isMultiDCEnabled), ulApiOrigin);
    this.oauth = ULRequest.postJson(appendMultiDCPath('/ul/api/v1/oauth', isMultiDCEnabled), ulApiOrigin);
    this.initialForgotPassword = ULRequest.getJson(appendMultiDCPath('/ul/api/v1/forgot-password', isMultiDCEnabled), ulApiOrigin);
    this.forgotPasswordEmail = ULRequest.postJson(appendMultiDCPath('/ul/api/v1/forgot-password/email', isMultiDCEnabled), ulApiOrigin);
    this.forgotPasswordPhone = ULRequest.postJson(appendMultiDCPath('/ul/api/v1/forgot-password/phone', isMultiDCEnabled), ulApiOrigin);
    this.initialChangePassword = ULRequest.getJson(appendMultiDCPath('/ul/api/v1/change-password', isMultiDCEnabled), ulApiOrigin);
    this.changePassword = ULRequest.postJson(appendMultiDCPath('/ul/api/v1/change-password', isMultiDCEnabled), ulApiOrigin);
    this.initialSignup = ULRequest.getJson(appendMultiDCPath('/ul/api/v1/signup', isMultiDCEnabled), ulApiOrigin);
    this.signup = ULRequest.postJson(appendMultiDCPath('/ul/api/v1/signup', isMultiDCEnabled), ulApiOrigin);
    this.deleteAccount = ULRequest.patchJson('/ul/api/v1/account/delete', ulApiOrigin);
    this.getChannels = ULRequest.getJson('/ul/api/v1/mfa/citi/getChannels', ulApiOrigin);
    this.generateOtp = ULRequest.postJson('/ul/api/v1/mfa/citi/generateOtp', ulApiOrigin);
    this.verifyOtp = ULRequest.postJson('/ul/api/v1/mfa/citi/verifyOtp', ulApiOrigin);
    this.refreshToken = ULRequest.postJson('/partner/token/refresh', ulApiOrigin);
    this.sendAuthedOtp = ULRequest.postJson(appendMultiDCPath('/ul/api/v1/otp/sendAuthed', isMultiDCEnabled), ulApiOrigin);
    this.verifyOtpV2 = ULRequest.postJson(appendMultiDCPath('/ul/api/v1/otp/verify', isMultiDCEnabled), ulApiOrigin);
    this.verifyAuthedOtp = ULRequest.postJson(appendMultiDCPath('/ul/api/v1/otp/verifyAuthed', isMultiDCEnabled), ulApiOrigin);
    this.initializePhoneAssociation = ULRequest.getJson(appendMultiDCPath('/ul/api/v1/associate/phone', isMultiDCEnabled), ulApiOrigin);
    this.verifyPhoneAssociation = ULRequest.postJson(appendMultiDCPath('/ul/api/v1/associate/phone', isMultiDCEnabled), ulApiOrigin);
    this.verifyWhatsappLink = ULRequest.postJson(appendMultiDCPath('/ul/api/v1/associate/whatsapplink', isMultiDCEnabled), ulApiOrigin);
    this.associateSocial = function(socialType, request, headers) {
        return ULRequest.postJson(appendMultiDCPath("/ul/api/v1/associate/social", isMultiDCEnabled), ulApiOrigin)(request, headers);
    };
    this.signInCallback = ULRequest.postJson(appendMultiDCPath('/ul/api/v1/signin/callbackAction', isMultiDCEnabled), ulApiOrigin);
    this.validateToken = ULRequest.postJson(appendMultiDCPath('/ul/api/v1/validate/token', isMultiDCEnabled), ulApiOrigin);
    this.authLogin = ULRequest.postJson(appendMultiDCPath('/ul/api/v1/auth', isMultiDCEnabled), ulApiOrigin);
    this.forceLogout = ULRequest.postJson('/ul/api/v1/logoutOfAllDevices', ulApiOrigin);
    this.resetPin = ULRequest.postJson('/ul/api/v1/pin/reset', ulApiOrigin);
    this.walletAuth = ULRequest.postJson('/ul/api/v1/wallet/auth', ulApiOrigin);
    this.scaAuthen = ULRequest.postJson('/ul/api/v1/sca/authen', ulApiOrigin);
    this.scaInit = ULRequest.postJson('/ul/api/v1/sca/init', ulApiOrigin);
    this.signUpConsent = ULRequest.postJson('/ul/api/v1/signup/consent', ulApiOrigin);
    this.getPasskeyRegistrationOptions = ULRequest.postJson(appendMultiDCPath('/ul/api/v1/passkey/register/options', isMultiDCEnabled), ulApiOrigin);
    this.registerPasskey = ULRequest.postJson(appendMultiDCPath('/ul/api/v1/passkey/register/verify', isMultiDCEnabled), ulApiOrigin);
    this.getPasskeyAuthenticationOptions = ULRequest.postJson(appendMultiDCPath('/ul/api/v1/passkey/authenticate/options', isMultiDCEnabled), ulApiOrigin);
    this.authenticateWithPasskey = ULRequest.postJson(appendMultiDCPath('/ul/api/v1/passkey/authenticate/verify', isMultiDCEnabled), ulApiOrigin);
    this.getUserPasskeys = ULRequest.getJson(appendMultiDCPath('/ul/api/v1/passkey/list', isMultiDCEnabled), ulApiOrigin);
    this.updatePasskeyFriendlyName = ULRequest.patchJson(appendMultiDCPath('/ul/api/v1/passkey/update', isMultiDCEnabled), ulApiOrigin);
    this.deleteUserPasskey = ULRequest.deleteJson(appendMultiDCPath('/ul/api/v1/passkey', isMultiDCEnabled), ulApiOrigin);
};

export { ULRequestUniversalLoginApiClient };
